.me-dropdown {
  position: static;
  display: block;
  width: 100%;

  @include desktop-lg {
    display: inline-flex;
    align-items: center;
    width: auto;
  }

  .me-button {
    justify-content: space-between;
    padding: 0;

    @include desktop-lg {
      width: auto;
      padding: initial;
      justify-content: initial;
    }

    &--icon-after {
      .me-icon {
        position: relative;
        left: calc(-1 * var(--spacing-xs));
      }

      &::before {
        display: none;

        @include desktop-lg {
          display: initial;

          // Explicitly set left and right to prevent positioning shift when hovering over margin area
          // Higher specificity: .me-dropdown .me-button--icon-after::before (0,2,1)
          // vs .me-button--ghost.me-button--icon-after::before (0,2,1)
          // This wins due to cascade order
          left: 0;
          right: calc(var(--spacing-xl) + var(--spacing-2xs));
        }
      }

      .me-button__icon {
        @include size(var(--spacing-xl));

        aspect-ratio: 1;
        transition: transform 0.3s ease;
      }
    }

    &:hover {
      .me-button__icon {
        opacity: 1;
      }
    }

    // Higher specificity for hover: .me-dropdown .me-button.me-button--icon-after:hover::before (0,3,2)
    // vs .me-button--ghost.me-button--icon-after:hover::before (0,3,1)
    // This wins due to higher specificity
    &.me-button--icon-after:hover::before {
      @include desktop-lg {
        // Ensure left and right positions are fixed on hover to prevent shift
        left: 0;
        right: calc(var(--spacing-xl) + var(--spacing-2xs));
      }
    }

    &.is-active {
      .me-button__icon {
        transform: rotate(180deg);
      }

      &--icon-after::before {
        @include desktop-lg {
          width: calc(100% - (var(--spacing-xl) + var(--spacing-2xs)));

          // Ensure left and right positions are fixed when active
          left: 0;
          right: calc(var(--spacing-xl) + var(--spacing-2xs));
        }
      }
    }
  }

  &__menu {
    position: relative;
    width: 100%;
    border: 0;
    margin: 0;
    padding: 0 var(--spacing-md);
    max-height: 0;
    overflow: hidden;
    transform: none;

    @include desktop-lg {
      position: absolute;
      top: var(--spacing-2xl);
      left: 0;
      z-index: 1000;
      padding: var(--spacing-xl);
      border: var(--border-size-sm) solid var(--color-neutral-black);
      background: var(--color-neutral-white);
      opacity: 0;
      visibility: hidden;
      transform: translateY(var(--spacing-xs));
      transition: all 0.2s cubic-bezier(0.165, 0.84, 0.44, 1);
      overflow: hidden;
      width: auto;
      margin: initial;
      max-height: initial;

      .me-button {
        white-space: nowrap;
      }
    }

    &--open {
      max-height: 100%;
      opacity: 1;
      visibility: visible;
      padding-top: var(--spacing-md);
      padding-bottom: var(--spacing-md);

      @include desktop-lg {
        padding-top: var(--spacing-xl);
        padding-bottom: var(--spacing-xl);
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
        max-height: initial;
        transition: all 0.2s cubic-bezier(0.165, 0.84, 0.44, 1);
        box-shadow: 0 4px 12px rgb(44 44 44 / 12%);
      }
    }
  }
}
